export function resolveCurrentUserResponse(response, fallbackUser) {
  const isCurrentUserResponse = Boolean(
    response
    && typeof response === 'object'
    && !Array.isArray(response)
    && typeof response._id === 'string'
    && response._id.trim()
  );

  return isCurrentUserResponse ? response : fallbackUser;
}
